import script from "./SideBarListBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarListBox.vue?vue&type=script&setup=true&lang=js"

import "./SideBarListBox.vue?vue&type=style&index=0&id=3eb45ffc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb45ffc"]])

export default __exports__